/* Illustrative carrier / partner logos rendered inline (no external assets).
   Replace with real partner SVGs once partnerships are signed. */
import useReveal from "../hooks/useReveal";

const PARTNERS = [
    "MAERSK", "MSC", "ONE", "CMA CGM", "HAPAG-LLOYD",
    "EVERGREEN", "ANL", "SHIPSGO", "VIZION", "ONESTOP",
];

export default function LogoStrip() {
    const [ref, visible] = useReveal();
    return (
        <section
            data-testid="logo-strip-section"
            className="relative border-t border-white/5 py-10 sm:py-14 bg-[#08080C]"
        >
            <div ref={ref} className={`reveal ${visible ? "is-visible" : ""} max-w-7xl mx-auto px-4 sm:px-6 lg:px-8`}>
                <p className="text-center text-xs font-mono-accent text-zinc-500 tracking-[0.3em] uppercase mb-8">
                    Carrier &amp; data ecosystem · illustrative
                </p>
                <div className="grid grid-cols-2 sm:grid-cols-5 gap-x-6 gap-y-5 items-center">
                    {PARTNERS.slice(0, 10).map((p) => (
                        <div
                            key={p}
                            data-testid={`logo-${p.toLowerCase().replace(/[^a-z0-9]/g, "-")}`}
                            className="flex items-center justify-center"
                        >
                            <span className="font-display text-zinc-500 hover:text-cyan-300 transition-colors text-base sm:text-lg tracking-tight">
                                {p}
                            </span>
                        </div>
                    ))}
                </div>
                <p className="text-center text-[10px] font-mono-accent text-zinc-600 mt-7">
                    LOGOS SHOWN ARE INDICATIVE OF THE CARRIER &amp; DATA-PROVIDER ECOSYSTEM WE PLAN TO INTEGRATE WITH
                </p>
            </div>
        </section>
    );
}
